import { render, staticRenderFns } from "./LogPassPremiumSea.vue?vue&type=template&id=c899c3f8&"
import script from "./LogPassPremiumSea.vue?vue&type=script&lang=js&"
export * from "./LogPassPremiumSea.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports